module.exports = __webpack_public_path__ + "img/202308030939596092bu.39e02770.jpg";